export default __webpack_public_path__ + "images/package.9062b13.svg";